module.exports = __webpack_public_path__ + "FixelDisplay-Bold.5629cc82106afc318f8b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelDisplay/FixelDisplay-Bold.woff2
// module id = ./src/assets/webfonts/fixelDisplay/FixelDisplay-Bold.woff2
// module chunks = styles